import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { AgentVersionDisplay } from '../types';
import { getScoreClassName, getStatusClassName, getStatusLabel } from '../utils';

export function AgentVersionCell({ display }: { display: AgentVersionDisplay }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground">
      <span>{display.version}</span>
      {display.tag ? (
        <Badge variant="outline" className="border-border bg-muted/30 px-1.5 py-0 text-[11px] font-normal text-muted-foreground">
          {display.tag}
        </Badge>
      ) : null}
    </div>
  );
}

export function ScoreBadge({ score, prefix = 'Score' }: { score?: number | null; prefix?: string }) {
  if (score == null) {
    return (
      <Badge variant="outline" className="border-border bg-muted/40 text-xs font-normal text-muted-foreground">
        No score
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className={cn('text-xs font-normal tabular-nums', getScoreClassName(score))}>
      {prefix} {score}
    </Badge>
  );
}

export function RunStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant="outline" className={cn('text-xs font-normal', getStatusClassName(status))}>
      {getStatusLabel(status)}
    </Badge>
  );
}
